import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { OfflineDetectionService } from '../services/offline-detection.service';

export const offlineInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const offlineDetection = inject(OfflineDetectionService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0 && !navigator.onLine) {
        offlineDetection.recheckIfDismissed();
      }

      return throwError(() => error);
    }),
  );
};
